const state = {
  // 外部信用评价 信息
  creditEvaluationObject:{},
  // 创新和曝光做法 信息
  innovationAndExposureObject:{}
}

export default state
